import { rem } from '@mantine/core';
import { DateInput } from '@mantine/dates';

export default DateInput.extend({
  defaultProps: {
    size: 'md',
    valueFormat: 'DD/MM/YYYY',
  },
  styles: () => ({
    root: { width: rem(180) },
  }),
});
